// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"8fa1053f","229":"02b542ba","373":"8d2b90b1","469":"27f1cec4","510":"e73633d5","808":"e92cbe49"}[chunkId] + ".css";
};